export default "__VITE_ASSET__DJLfbf3F__"